import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import ComingSoon from "./sections/ComingSoon";
import TheCorePhilosophy from "./sections/TheCorePhilosophy";
import TradingStrategiesPreview from "./sections/TradingStrategiesPreview";
import TheAiProtocol from "./sections/TheAiProtocol";
import StrategicUpdates from "./sections/StrategicUpdates";
import InvestorFaq from "./sections/InvestorFaq";
import StoreFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <ComingSoon />
      <TheCorePhilosophy />
      <TradingStrategiesPreview />
      <TheAiProtocol />
      <StrategicUpdates />
      <InvestorFaq />
      <StoreFooter />
    </div>;
}